<template>
  <pt-banner-manage class="pt-banner-manage__page"></pt-banner-manage>
</template>

<script>
import PtBannerManage from 'cps/mall-manage/recommend-manage/pt-banner-manage/withData'
export default {
  name: 'pt-banner-manage__view',
  components: {
    'pt-banner-manage': PtBannerManage
  }
}
</script>
